/**
 * Pure H OS · Phase D Wave 4 · Customer 360 (types + live view).
 * MongoDB collection: `pureh_customers`.
 */
import { liveArray } from "../services/store";

export type CustomerSegment = "Retail" | "Wholesale";
export type CustomerTier = "Founder" | "VIP" | "Loyal" | "New" | "Lapsed" | "Partner" | "Prospect";
export type RetentionRisk = "low" | "medium" | "high";

export type Customer360Row = {
  id: string;
  name: string;
  segment: CustomerSegment;
  tier: CustomerTier;
  lifetimeOrders: number;
  lifetimeSpendEGP: number;
  lastOrderRelative: string;
  nps: number;
  retentionRisk: RetentionRisk;
  preferredChannel: string;
};

export const CUSTOMERS_360: Customer360Row[] = liveArray<Customer360Row>("customers");
